import { Ito, Procedure } from './Yubinuki';

function defaultIto(): Ito {
    return {
        color: '808080',
        rounds: 0,
    };
}

function defaultProcedure(groupNo: number): Procedure {
    let ito = defaultIto();
    return {
        groupNo: groupNo,
        matomeSasi: false,
        sasiType: 0,
        itos:[ito],
        connectedRounds: 1,
        offset: 0,
    };
}

export default {
    defaultIto: defaultIto,
    defaultProcedure: defaultProcedure,
};
